import { baseApi } from "utils/axios/baseApi";
import { CHATTER_TEMPLATE_CREATE, CHATTER_TEMPLATE_DELETE, CHATTER_TEMPLATE_LIST, CHATTER_TEMPLATE_UPDATE, CHATTER_TEMPLATE_VIEW } from "config/apiPaths";

const chatterTemplateManagementApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({

    getChatterTemplateList: builder.query({
      query: ({ page, limit, search, sort }) => ({
        method: "PATCH",
        url: CHATTER_TEMPLATE_LIST,
        data: {
          page,
          limit,
          search,
          sort
        }
      }),
      transformResponse: (response) => {
        return response.data;
      },
      providesTags: ['chatterTemplateList']
    }),

    createChatterTemplate: builder.mutation({
      query: ({ body }) => ({
        method: "POST",
        url: `${CHATTER_TEMPLATE_CREATE}`,
        data: body
      }),
      transformResponse: (response) => {
        return response.data;
      },
      invalidatesTags: ['chatterTemplateList']
    }),

    deleteChatterTemplate: builder.mutation({
      query: ({ id }) => ({
        method: "DELETE",
        url: `${CHATTER_TEMPLATE_DELETE}/${id}`,
      }),
      transformResponse: (response) => {
        return response.data;
      },
      invalidatesTags: ['chatterTemplateList']
    }),

    getChatterTemplate: builder.query({
      query: ({ id }) => ({
        method: "GET",
        url: `${CHATTER_TEMPLATE_VIEW}/${id}`,
      }),
      transformResponse: (response) => {
        return response.data;
      },
      providesTags: ['chatterTemplateDetail']
    }),

    updateChatterTemplate: builder.mutation({
      query: ({ body, id }) => ({
        method: "PATCH",
        url: `${CHATTER_TEMPLATE_UPDATE}/${id}`,
        data: body
      }),
      transformResponse: (response) => {
        return response.data;
      },
      invalidatesTags: ['chatterTemplateList', 'chatterTemplateDetail']
    }),
  })
})

export const {
  useGetChatterTemplateListQuery,
  useCreateChatterTemplateMutation,
  useDeleteChatterTemplateMutation,
  useGetChatterTemplateQuery,
  useUpdateChatterTemplateMutation,
} = chatterTemplateManagementApi